var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.755,
    height: 33.32,
    viewBox: "0 0 34.755 33.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8273",
    "data-name": "\\uADF8\\uB8F9 8273",
    transform: "translate(-17.541 -18.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12445",
    "data-name": "\\uD328\\uC2A4 12445",
    d: "M82.893,47.129V60.214A4.989,4.989,0,0,1,79.6,64.907V52.324A7.164,7.164,0,0,0,72.45,45.17H53.992a4.989,4.989,0,0,1,4.589-3.033H77.906a4.989,4.989,0,0,1,4.987,4.992",
    transform: "translate(-30.598 -23.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12446",
    "data-name": "\\uD328\\uC2A4 12446",
    d: "M69.781,59.124v13.09A4.985,4.985,0,0,1,64.794,77.2H58.906a1.852,1.852,0,0,1-.221.468l-2.76,4.095a.9.9,0,0,1-1.6,0L51.579,77.7a1.768,1.768,0,0,1-.23-.494h-5.88a4.985,4.985,0,0,1-4.987-4.987V59.124a4.988,4.988,0,0,1,4.987-4.987H64.794a4.988,4.988,0,0,1,4.987,4.987",
    transform: "translate(-22.941 -30.68)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.9e9691738067148d3344dcc78d6c922f.svg";
export { ForwardRef as ReactComponent };